export default __webpack_public_path__ + "static/media/review_group.189f9632.svg";